import TasksBoard from "./Kanban/TasksBoard";
import { Helmet } from "react-helmet";
import SecondHeader from "../Header/SecondHeader";
import trans from "../../utils";
import { useContext, useState } from "react";
import { popupcontext } from "../../context/Popupscontext";
import TasksForm from "./Forms/TasksForm";
import TasksHeader from "./TasksHeader";
import TasksList from "./List/TasksList";
import dayjs from "dayjs";
import TasksBoardGroupByPOI from "./Kanban/TasksBoardGroupByPOI";
import TasksBoardGroupByFieldStaff from "./Kanban/TasksBoardGroupByFieldStaff";
import usePermission from "../../hooks/usePermission";
import AccessDenied from "../AccessDenied";
import TaskBulkUpload from "./BulkUpload/TaskBulkUpload";

const Tasks = () => {
	let { handleShow } = useContext(popupcontext);
	const [viewMode, setViewMode] = useState("Kanban");
	const [selectedDate, setSelectedDate] = useState(dayjs());
	const [selectedRange, setSelectedRange] = useState([
		dayjs().startOf("day"), // from today
		dayjs().endOf("day"), // to today
	]);
	const [selectedPOIs, setSelectedPOIs] = useState([]);
	const [selectedStaff, setSelectedStaff] = useState([]);
	const [refresh, setRefresh] = useState(false);
	const [refreshing, setRefreshing] = useState(false);
	const fromDate = selectedDate.startOf("day").format("YYYY-MM-DDTHH:mm:ss");
	const toDate = selectedDate.endOf("day").format("YYYY-MM-DDTHH:mm:ss");
	const fromDateList = selectedRange?.[0]?.format("YYYY-MM-DDTHH:mm:ss");
	const toDateList = selectedRange?.[1]?.format("YYYY-MM-DDTHH:mm:ss");

	const { view, create } = usePermission("FIELD_TASKS");
	const [showBulkUpload, setShowBulkUpload] = useState(false);

	return (
		<>
			<Helmet>
				<title>Tasks Board</title>
				<meta name="description" content="Users" />
			</Helmet>
			<SecondHeader
				add={create ? trans("Add new task") : null}
				onClick={() => handleShow("addForm")}
				secButton={create ? trans("Bulk Add Tasks") : null}
				secClick={() => setShowBulkUpload(true)}
			/>
			<TasksHeader
				viewMode={viewMode}
				setViewMode={setViewMode}
				selectedDate={selectedDate}
				setSelectedDate={setSelectedDate}
				selectedRange={selectedRange}
				setSelectedRange={setSelectedRange}
				selectedPOIs={selectedPOIs}
				setSelectedPOIs={setSelectedPOIs}
				selectedStaff={selectedStaff}
				setSelectedStaff={setSelectedStaff}
			/>
			{viewMode === "Kanban" && (
				<TasksBoard
					fromDate={fromDateList}
					toDate={toDateList}
					setRefresh={setRefresh}
					refresh={refresh}
					setRefreshing={setRefreshing}
					viewMode={viewMode}
				/>
			)}
			{viewMode === "Kanban - POI" && (
				<TasksBoardGroupByPOI
					fromDate={fromDateList}
					toDate={toDateList}
					setRefresh={setRefresh}
					refresh={refresh}
					setRefreshing={setRefreshing}
					viewMode={viewMode}
					selectedPOIs={selectedPOIs}
					showBy="poi"
				/>
			)}
			{viewMode === "Kanban - Staff" && (
				<TasksBoardGroupByFieldStaff
					fromDate={fromDateList}
					toDate={toDateList}
					setRefresh={setRefresh}
					refresh={refresh}
					setRefreshing={setRefreshing}
					viewMode={viewMode}
					selectedStaff={selectedStaff}
					showBy="fieldStaff"
				/>
			)}

			{viewMode === "List" && (
				<TasksList
					fromDate={fromDateList}
					toDate={toDateList}
					setRefresh={setRefresh}
					refresh={refresh}
					setRefreshing={setRefreshing}
				/>
			)}
			<TasksForm />
			<TaskBulkUpload
				show={showBulkUpload}
				onClose={() => setShowBulkUpload(false)}
			/>
		</>
	);
};

export default Tasks;
